module.exports = __webpack_public_path__ + "static/media/handoff-schedule-m.91acbff1.png";